import React from 'react';
import './ChatActionsSidebar.css';
import AppIcon from './icons/AppIcon';

/**
 * Sidebar de ações rápidas para conversas
 * Exibida no lado direito da área de chat
 */
export default function ChatActionsSidebar({ 
  conversationId, 
  isFavorited = false,
  onEditContact,
  onDelete, 
  onToggleFavorite, 
  onExportPDF 
}) {
  return (
    <div className="halo-chat-actions-sidebar">
      <button
        className="halo-action-button"
        data-tooltip="Editar contato"
        onClick={onEditContact}
        disabled={!onEditContact}
      >
        <AppIcon name="edit" />
      </button>

      {/* Excluir conversa */}
      <button
        className="halo-action-button"
        data-tooltip="Excluir conversa"
        onClick={onDelete}
      >
        <AppIcon name="delete" />
      </button>

      {/* Favoritar */}
      <button
        className={`halo-action-button ${isFavorited ? 'favorited' : ''}`}
        data-tooltip={isFavorited ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
        onClick={onToggleFavorite}
      >
        <AppIcon name={isFavorited ? 'star' : 'star_border'} />
      </button>

      {/* Exportar PDF */}
      <button
        className="halo-action-button"
        data-tooltip="Exportar para PDF"
        onClick={onExportPDF}
      >
        <AppIcon name="description" />
      </button>
    </div>
  );
}
